<template>
  <div class="container">
    <div class="block1">
      <div class="left">
        <div class="card">
          <div class="card-title">
            <p class="title">门店数据</p>
            <div class="btns">
              <div class="text">当天</div>
            </div>
          </div>
          <div class="store-data-wrap">
            <div class="item" @click="toTimeSchedule">
              <p class="name">待点名人次</p>
              <p class="number">{{ rollcallData.no_roll_call_student }}</p>
            </div>
            <div class="item" @click="toRollcallStudent('[1,2]')">
              <p class="name">点名实到人次</p>
              <p class="number">{{ rollcallData.roll_call_attend_student }}</p>
            </div>
            <div class="item" @click="toRollcallStudent('[3]')">
              <p class="name">点名请假人次</p>
              <p class="number">{{ rollcallData.roll_call_leave_student }}</p>
            </div>
            <div class="item" @click="toRollcallStudent('[4]')">
              <p class="name">点名未到人次</p>
              <p class="number">{{ rollcallData.roll_call_absent_student }}</p>
            </div>
          </div>
        </div>
        <div class="card cost-lesson-wrap">
          <div class="card-title">
            <p class="title">耗课数</p>
            <div class="btns">
              <div
                class="text"
                style="cursor: pointer"
                @click="toEducationalStatistics"
              >
                查看 >
              </div>
            </div>
          </div>
          <div v-if="showConsumeClassHour">
            <div class="cost-lesson" id="echart1"></div>
          </div>
          <div class="no-data" v-else>
            <img
              class="person"
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/integral/no-data.png"
              alt=""
            />
            <p class="img-text">暂无内容</p>
          </div>
        </div>
      </div>
      <div class="card right">
        <div class="card-title">
          <p class="title">门店待办事项</p>
        </div>
        <div class="todo-list-wrap">
          <div class="no-data" v-if="todoListLength === 0">暂无待办</div>
          <div
            class="item"
            v-if="todoList.no_roll_call_lesson"
            @click="handleTodolistLink('time-out-no-rollcall')"
          >
            <span class="tag">超时未点</span>
            <p class="text">
              共<span class="num">{{ todoList.no_roll_call_lesson }}</span
              >个未点课次;
            </p>
          </div>
          <div
            class="item"
            v-if="todoList.exceed_student"
            @click="handleTodolistLink('lesson-cost-exceed')"
          >
            <span class="tag">超上课时</span>
            <p class="text">
              共<span class="num">{{ todoList.exceed_student }}</span
              >个学员超上课时;
            </p>
          </div>
          <div
            class="item"
            v-if="todoList.approval_init_order"
            @click="handleTodolistLink('waiting-approval')"
          >
            <span class="tag">订单审批</span>
            <p class="text">
              共<span class="num">{{ todoList.approval_init_order }}</span
              >个订单未审批;
            </p>
          </div>
          <div
            class="item"
            v-if="todoList.leave_pending_student"
            @click="handleTodolistLink('waiting-leave')"
          >
            <span class="tag">请假审批</span>
            <p class="text">
              共<span class="num">{{ todoList.leave_pending_student }}</span
              >个请假未审批;
            </p>
          </div>
          <div
            class="item"
            v-if="todoList.renew_student"
            @click="handleTodolistLink('renewal-reminder')"
          >
            <span class="tag">续费课程</span>
            <p class="text">
              共<span class="num">{{ todoList.renew_student }}</span
              >个待续费课程;
            </p>
          </div>
          <div
            class="item"
            v-if="todoList.no_follow_staff_latent_student"
            @click="handleTodolistLink('latent-with-no-staff')"
          >
            <span class="tag">待分配</span>
            <p class="text">
              共<span class="num">{{
                todoList.no_follow_staff_latent_student
              }}</span
              >个意向学员未分配课程顾问;
            </p>
          </div>
          <div
            class="item"
            v-if="todoList.no_class_ongoing_student"
            @click="handleTodolistLink('student-with-no-class')"
          >
            <span class="tag">分配班级</span>
            <p class="text">
              共<span class="num">{{ todoList.no_class_ongoing_student }}</span
              >个在读学员未分配班级;
            </p>
          </div>
          <div
            class="item"
            v-if="todoList.no_teacher_ongoing_student"
            @click="handleTodolistLink('student-with-no-teacher')"
          >
            <span class="tag">分配教务</span>
            <p class="text">
              共<span class="num">{{
                todoList.no_teacher_ongoing_student
              }}</span
              >个在读学员未分配教务老师;
            </p>
          </div>
          <div
            class="item"
            v-if="todoList.no_follow_staff_ongoing_student"
            @click="handleTodolistLink('student-with-no-staff')"
          >
            <span class="tag">分配顾问</span>
            <p class="text">
              共<span class="num">{{
                todoList.no_follow_staff_ongoing_student
              }}</span
              >个在读学员未分配课程顾问;
            </p>
          </div>
          <div
            class="item"
            v-if="todoList.no_teacher_one2many_class"
            @click="handleTodolistLink('multi-class-with-no-teacher')"
          >
            <span class="tag">分配教师</span>
            <p class="text">
              共<span class="num">{{ todoList.no_teacher_one2many_class }}</span
              >个1vN班级学员未分配授课教师;
            </p>
          </div>
          <div
            class="item"
            v-if="todoList.no_teacher_one2one_class"
            @click="handleTodolistLink('single-class-with-no-teacher')"
          >
            <span class="tag">分配教师</span>
            <p class="text">
              共<span class="num">{{ todoList.no_teacher_one2one_class }}</span
              >个1v1班级学员未分配授课教师;
            </p>
          </div>
          <div
            class="item"
            v-if="todoList.tobe_exchange_integral_student"
            @click="handleTodolistLink('waiting-exchange')"
          >
            <span class="tag">兑换记录</span>
            <p class="text">
              共<span class="num">{{
                todoList.tobe_exchange_integral_student
              }}</span
              >个待兑换记录;
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="block2">
      <div class="left people-total-wrap">
        <div class="card-title-wrap">
          <div class="card-title">
            <p class="title">人员统计</p>
          </div>
        </div>
        <div class="people-total">
          <div class="row">
            <div class="icon">
              <img
                src="https://wowsite.musicwow.com/teaching_system_frontend/images/home/icon-staff.png"
              />
            </div>
            <div class="item" @click="peopleTotalLink('all-staff')">
              <p class="number">{{ memberData.staff }}</p>
              <p class="name">员工总数</p>
            </div>
            <div class="item" @click="peopleTotalLink('all-teacher')">
              <p class="number">{{ memberData.teacher }}</p>
              <p class="name">授课教师</p>
            </div>
          </div>
          <div class="row">
            <div class="icon">
              <img
                src="https://wowsite.musicwow.com/teaching_system_frontend/images/home/icon-latent.png"
              />
            </div>
            <div class="item" @click="peopleTotalLink('all-latent')">
              <p class="number">{{ memberData.latent_student }}</p>
              <p class="name">意向学员</p>
            </div>
            <div class="item" @click="peopleTotalLink('new-latent')">
              <p class="number">
                <span class="plus" v-if="memberData.today_latent_student"
                  >+</span
                >
                {{ memberData.today_latent_student }}
              </p>
              <p class="name">今日新增意向</p>
            </div>
          </div>
          <div class="row">
            <div class="icon">
              <img
                src="https://wowsite.musicwow.com/teaching_system_frontend/images/home/icon-exp.png"
              />
            </div>
            <div class="item" @click="peopleTotalLink('today-experience')">
              <p class="number">{{ memberData.today_experience_student }}</p>
              <p class="name">今日体验</p>
            </div>
            <div class="item" @click="peopleTotalLink('finish-experience')">
              <p class="number">
                {{ memberData.today_finished_experience_student }}
              </p>
              <p class="name">今日完成体验</p>
            </div>
          </div>
          <div class="row">
            <div class="icon">
              <img
                src="https://wowsite.musicwow.com/teaching_system_frontend/images/home/icon-online.png"
              />
            </div>
            <div class="item" @click="peopleTotalLink('all-student')">
              <p class="number">{{ memberData.ongoing_student }}</p>
              <p class="name">在读学员</p>
            </div>
            <div class="item" @click="peopleTotalLink('new-student')">
              <p class="number">
                <span class="plus" v-if="memberData.today_ongoing_student"
                  >+</span
                >
                {{ memberData.today_ongoing_student }}
              </p>
              <p class="name">今日新增在读</p>
            </div>
          </div>
          <div class="row">
            <div class="icon">
              <img
                src="https://wowsite.musicwow.com/teaching_system_frontend/images/home/icon-history.png"
              />
            </div>
            <div class="item" @click="peopleTotalLink('all-history')">
              <p class="number">{{ memberData.past_student }}</p>
              <p class="name">历史学员</p>
            </div>
            <div class="item" @click="peopleTotalLink('today-completion')">
              <p class="number">
                <span class="plus" v-if="memberData.today_completion_student"
                  >+</span
                >
                {{ memberData.today_completion_student }}
              </p>
              <p class="name">今日结业学员</p>
            </div>
          </div>
          <div class="row">
            <div class="icon">
              <img
                src="https://wowsite.musicwow.com/teaching_system_frontend/images/home/icon-end.png"
              />
            </div>
            <div class="item" @click="peopleTotalLink('all-end')">
              <p class="number">{{ memberData.course_stop_student }}</p>
              <p class="name">停课学员</p>
            </div>
            <div class="item" @click="peopleTotalLink('today-end')">
              <p class="number">
                <span class="plus" v-if="memberData.today_course_stop_student"
                  >+</span
                >
                {{ memberData.today_course_stop_student }}
              </p>
              <p class="name">今日停课学员</p>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="top flex">
          <div class="stdent-table-wrap">
            <div class="head">
              <div class="tabs">
                <div
                  :class="`tab ${followActiveTab === 'today' ? 'active' : ''}`"
                  @click="followTabChange('today')"
                >
                  今日待跟进
                </div>
                <div
                  :class="`tab ${followActiveTab === 'outday' ? 'active' : ''}`"
                  @click="followTabChange('outday')"
                >
                  逾期未跟进
                </div>
              </div>
              <div class="btns">
                <div class="my">我的</div>
                <div class="all" @click="toFollow">查看全部 ></div>
              </div>
            </div>
            <div class="stdent-table">
              <el-table
                class="mwow-table"
                v-horizontal-scroll
                size="mini"
                :data="followTableData"
                stripe
                style="width: 100%"
                tooltip-effect="dark"
              >
                <el-table-column label="学员姓名" prop="student.name">
                  <template slot-scope="scope"
                    ><span class="blue">{{
                      (scope.row.student && scope.row.student.name) || "-"
                    }}</span></template
                  >
                </el-table-column>
                <el-table-column label="手机号" prop="student.mobile">
                  <template slot-scope="scope">
                    {{ "+" + scope.row.student.area_code }}
                    {{ scope.row.student.mobile }}
                  </template>
                </el-table-column>
                <el-table-column label="跟进状态" prop="status">
                  <template slot-scope="scope">
                    <span v-if="scope.row.status === 1">待跟进</span>
                    <span v-if="scope.row.status === 3">已逾期</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="课程顾问"
                  prop="follow_staff.name"
                ></el-table-column>
                <el-table-column
                  label="计划时间"
                  prop="pre_follow_time"
                ></el-table-column>
                <el-table-column
                  label="跟进内容"
                  prop="content"
                ></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <log-follow-dialog
                      :logData="scope.row"
                      :modeList="followModeList"
                      :lantentList="followLatentList"
                      :stageList="followStageList"
                    >
                      <div class="mwow-button primary">跟进</div>
                    </log-follow-dialog>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="card student-birthday-wrap">
            <div class="card-title">
              <p class="title">学员生日</p>
            </div>
            <div class="birthday-wrap">
              <div class="birthday-item flex">
                <div
                  class="birthday-left flex"
                  @click="toStudentBirthday('today')"
                >
                  <div class="birthday-icon">
                    <img
                      src="https://wowsite.musicwow.com/teaching_system_frontend/images/student/birthday.png"
                    />
                  </div>
                  <div class="birthday-text">今天生日</div>
                  <div class="birthday-count">
                    {{ studentBirthdayData.today }}
                  </div>
                </div>
                <div
                  class="birthday-right flex"
                  @click="toStudentBirthday('tomorrow')"
                >
                  <div class="birthday-icon">
                    <img
                      src="https://wowsite.musicwow.com/teaching_system_frontend/images/student/birthday.png"
                    />
                  </div>
                  <div class="birthday-text">明天生日</div>
                  <div class="birthday-count">
                    {{ studentBirthdayData.tomorrow }}
                  </div>
                </div>
              </div>

              <div class="birthday-item flex">
                <div
                  class="birthday-left flex"
                  @click="toStudentBirthday('this_week')"
                >
                  <div class="birthday-icon">
                    <img
                      src="https://wowsite.musicwow.com/teaching_system_frontend/images/student/birthday.png"
                    />
                  </div>
                  <div class="birthday-text">本周生日</div>
                  <div class="birthday-count">
                    {{ studentBirthdayData.this_week }}
                  </div>
                </div>
                <div
                  class="birthday-right flex"
                  @click="toStudentBirthday('next_week')"
                >
                  <div class="birthday-icon">
                    <img
                      src="https://wowsite.musicwow.com/teaching_system_frontend/images/student/birthday.png"
                    />
                  </div>
                  <div class="birthday-text">下周生日</div>
                  <div class="birthday-count">
                    {{ studentBirthdayData.next_week }}
                  </div>
                </div>
              </div>

              <div class="birthday-item flex">
                <div
                  class="birthday-left flex"
                  @click="toStudentBirthday('this_month')"
                >
                  <div class="birthday-icon">
                    <img
                      src="https://wowsite.musicwow.com/teaching_system_frontend/images/student/birthday.png"
                    />
                  </div>
                  <div class="birthday-text">本月生日</div>
                  <div class="birthday-count">
                    {{ studentBirthdayData.this_month }}
                  </div>
                </div>
                <div
                  class="birthday-right flex"
                  @click="toStudentBirthday('this_quarter')"
                >
                  <div class="birthday-icon">
                    <img
                      src="https://wowsite.musicwow.com/teaching_system_frontend/images/student/birthday.png"
                    />
                  </div>
                  <div class="birthday-text">本季度生日</div>
                  <div class="birthday-count">
                    {{ studentBirthdayData.this_quarter }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="card buy-total-wrap">
            <div class="title">
              <p class="text">购课人次</p>
              <div class="btns">
                <el-select
                  v-model="buyCountTimeRange"
                  @change="handleBuyCountTimeRangeChange"
                >
                  <el-option label="近7天" value="week"></el-option>
                  <el-option label="近14天" value="twoweek"></el-option>
                  <el-option label="近30天" value="month"></el-option>
                </el-select>
              </div>
            </div>
            <div class="no-data" v-show="orderBuyListTotal === 0">暂无数据</div>
            <div
              class="buy-total"
              id="echart2"
              v-show="orderBuyListTotal !== 0"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts/core";
import { GridComponent, TooltipComponent } from "echarts/components";
import { LineChart, BarChart } from "echarts/charts";
import { UniversalTransition } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";
echarts.use([
  GridComponent,
  LineChart,
  BarChart,
  TooltipComponent,
  CanvasRenderer,
  UniversalTransition,
]);
// type EChartsOption = echarts.ComposeOption<
//   | GridComponentOption
//   | LineSeriesOption
//   | TooltipComponentOption
//   | BarSeriesOption
// >;
import {
  getHomepageDataApi,
  getOrderBuyDataApi,
  getFollowStudentListApi,
} from "@/api/home";
import { dateFormat } from "@/utils/timeFormat";
import {
  getFollowModeApi,
  getFollowStageApi,
  getFollowLatentApi,
} from "@/api/studentFollow";
import eventBus from "@/utils/bus";
import logFollowDialog from "@/view/recruit/follow/logFollowDialog.vue";
import {
  getEducationalListApi,
  studentBirthdayStatisticsApi,
} from "@/api/statistics";
import { UserModule } from "@/store/module/user";
import { switchDetailApi } from "@/api/storeManagement";

export default {
  components: {
    logFollowDialog,
  },
  data() {
    return {
      myChart1: {},
      myChart2: {},
      resizeMark: false,
      rollcallData: {},
      lessonCostList: [],
      todoList: {},
      todoListLength: -1,
      memberData: {},
      buyCountTimeRange: "month",
      orderBuyList: [],
      orderBuyListTotal: -1,
      followTableData: [],
      followActiveTab: "today",
      followStageList: [],
      followModeList: [],
      followLatentList: [],
      showConsumeClassHour: true,
      studentBirthdayData: {},
    };
  },
  created() {
    // 获取中心配置开关详情存储到localStorage
    switchDetailApi().then((res) => {
      if (res.error_code === 0) {
        const switchDetail = {
          free_courses: false,
          student_superupper: false,
          automatic_make_up: false,
          renew_auto_switch: false,
          renew_lesson_count: 5,
          renew_push_time: "09:00",
          new_buy_renew_time: 30,
        };
        switchDetail.free_courses = res.data.free_arrange_lesson === 1;
        switchDetail.student_superupper = res.data.student_exceed === 1;
        switchDetail.automatic_make_up =
          res.data.student_exceed_automatic_sub === 1;
        switchDetail.renew_auto_switch = res.data.renew_auto_switch === 1;
        switchDetail.renew_lesson_count = res.data.renew_lesson_count;
        switchDetail.renew_push_time = res.data.renew_push_time;
        switchDetail.new_buy_renew_time = res.data.new_buy_renew_time;
        localStorage.setItem("switch_type", JSON.stringify(switchDetail));
      }
    });
    this.getStudentBirthdayStatistics();
  },
  mounted() {
    // 中心数据，待办数据，人员统计
    getHomepageDataApi().then((res) => {
      this.rollcallData = res.data.roll_call_count_date;
      this.todoList = res.data.todo_count_data;
      let todoListLength = 0;
      for (const key in res.data.todo_count_data) {
        todoListLength = todoListLength + res.data.todo_count_data[key];
      }
      this.todoListLength = todoListLength;
      this.memberData = res.data.member_count_data;
    });
    // 最近30天耗课数
    getEducationalListApi({
      time_tag: "free",
      start_date: dateFormat(
        "YYYY-mm-dd",
        new Date().getTime() - 30 * 24 * 60 * 60 * 1000
      ),
      end_date: dateFormat("YYYY-mm-dd", new Date()),
    }).then((res) => {
      if (res.data === null) {
        this.showConsumeClassHour = false;
      }
      const lessonCostList = [];
      for (const date in res.data) {
        lessonCostList.push(res.data[date]);
      }
      this.lessonCostList = lessonCostList;
      this.renderChart1(res.data);
    });
    // 购课人次统计
    this.handleBuyCountTimeRangeChange(this.buyCountTimeRange);
    // 跟进表格
    this.followTabChange(this.followActiveTab);
    getFollowStageApi({}).then((res) => {
      this.followStageList = res.data.list;
    });
    getFollowModeApi().then((res) => {
      this.followModeList = res.data.list;
    });
    getFollowLatentApi().then((res) => {
      this.followLatentList = res.data.list;
    });
    // echart
    const chartDom1 = document.getElementById("echart1");
    this.myChart1 = echarts.init(chartDom1);
    const chartDom2 = document.getElementById("echart2");
    this.myChart2 = echarts.init(chartDom2);
    //绑定耗课数跳转事件
    this.myChart1.getZr().on("click", (params) => {
      const pointInPixel = [params.offsetX, params.offsetY];
      if (this.myChart1.containPixel("grid", pointInPixel)) {
        const xIndex = this.myChart1.convertFromPixel({ seriesIndex: 0 }, [
          params.offsetX,
          params.offsetY,
        ])[0];
        const date = this.lessonCostList[xIndex].lesson_date;
        this.$router.push({
          name: "rollCallRecord",
          query: {
            tab: "rollCallRecord",
          },
          params: {
            lesson_date_start: date,
            lesson_date_end: date,
          },
        });
      }
    });
    //绑定购课跳转事件
    this.myChart2.on("click", (params) => {
      const index = params.dataIndex;
      if (this.orderBuyList[index]) {
        if (
          this.orderBuyList[index].subject &&
          this.orderBuyList[index].subject.subject_id
        ) {
          this.toOrderLine(this.orderBuyList[index].subject.subject_id);
        }
      }
    });
    // 监听屏幕大小改动
    window.addEventListener("resize", () => {
      if (this.resizeMark) {
        return false;
      }
      this.resizeMark = true;
      setTimeout(() => {
        this.myChart1.resize();
        this.myChart2.resize();
        this.resizeMark = false;
      }, 1000);
    });
    // 监听左侧栏展开收起
    eventBus.$on("collapse", () => {
      setTimeout(() => {
        this.myChart1.resize();
        this.myChart2.resize();
      }, 100);
    });
    // 应对左侧栏收起的缓存状态
    if (localStorage.getItem("layout-collapse") === "close") {
      setTimeout(() => {
        this.myChart1.resize();
        this.myChart2.resize();
      }, 100);
    }
  },
  methods: {
    renderChart1(origin) {
      const x = [];
      const y = [];
      for (const key in origin) {
        x.push(key.slice(5));
        y.push(Number(origin[key].real_consume_number));
      }
      let option;
      option = {
        color: "#4FB77C",
        tooltip: {
          trigger: "axis",
          formatter: "{a}：{c}",
          backgroundColor: "rgba(0,0,0,0.7)",
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#ffffff",
          },
        },
        grid: {
          left: "0",
          right: "3%",
          bottom: "3%",
          top: "9%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: x,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "耗课数",
            data: y,
            type: "line",
            smooth: true,
            lineStyle: {
              width: 1,
            },
            symbol: "circle",
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(79,183,124)",
                },
                {
                  offset: 1,
                  color: "rgb(255,255,255)",
                },
              ]),
            },
          },
        ],
      };
      option && this.myChart1.setOption(option);
    },
    renderChart2(origin) {
      const x = [];
      const y = [];
      origin.map((item) => {
        x.push(item.subject.subject_title);
        y.push(item.buy_num);
      });
      let option;
      option = {
        color: [
          "#FF913D",
          "#FFB84A",
          "#A5CA28",
          "#5FC92D",
          "#4FB77C",
          "#13D0AA",
          "#35BDF4",
          "#49A1F9",
        ],
        tooltip: {
          trigger: "axis",
          formatter: "{a}：{c}",
          backgroundColor: "rgba(0,0,0,0.7)",
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#ffffff",
          },
        },
        xAxis: {
          type: "category",
          data: x,
        },
        yAxis: {
          type: "value",
        },
        grid: {
          left: "0",
          right: "0",
          top: "9%",
          bottom: "0",
          containLabel: true,
        },
        series: [
          {
            data: y,
            type: "bar",
            name: "购课人次",
            colorBy: "data",
            itemStyle: {
              borderRadius: 4,
            },
            barWidth: "20%",
          },
        ],
      };
      option && this.myChart2.setOption(option);
    },
    followTabChange(v) {
      this.followActiveTab = v;
      const status = v === "today" ? 1 : 3;
      getFollowStudentListApi({
        status: status,
        page: 1,
        page_size: 50,
      }).then((res) => {
        res.data.list.map((item) => {
          item.content = item.content || "-";
          item.pre_follow_time = dateFormat(
            "YYYY-mm-dd",
            item.pre_follow_time * 1000
          );
        });
        this.followTableData = res.data.list;
      });
    },
    handleBuyCountTimeRangeChange(v) {
      let start = "";
      let end = "";
      if (v === "week") {
        start = dateFormat(
          "YYYY-mm-dd",
          new Date().getTime() - 7 * 24 * 60 * 60 * 1000
        );
      } else if (v === "twoweek") {
        start = dateFormat(
          "YYYY-mm-dd",
          new Date().getTime() - 14 * 24 * 60 * 60 * 1000
        );
      } else if (v === "month") {
        start = dateFormat(
          "YYYY-mm-dd",
          new Date().getTime() - 30 * 24 * 60 * 60 * 1000
        );
      } else {
        return false;
      }
      end = dateFormat("YYYY-mm-dd", new Date());
      getOrderBuyDataApi({
        start_date: start,
        end_date: end,
      }).then((res) => {
        this.orderBuyList = res.data.list;
        let orderBuyListTotal = 0;
        res.data.list.map((item) => {
          orderBuyListTotal = orderBuyListTotal + item.buy_num;
        });
        this.orderBuyListTotal = orderBuyListTotal;
        this.renderChart2(res.data.list);
      });
    },
    toTimeSchedule() {
      // 跳转时间课表，日模式
      this.$router.push({
        name: "storeSchedule",
        params: {
          linkType: "to-day-view",
        },
      });
    },
    toRollcallStudent(arr) {
      this.$router.push({
        name: "rollCallRecord",
        query: {
          tab: "rollCallStudentList",
        },
        params: {
          type: "store-data",
          start_date: dateFormat("YYYY-mm-dd", new Date()),
          end_date: dateFormat("YYYY-mm-dd", new Date()),
          student_status_list: arr,
        },
      });
    },
    toEducationalStatistics() {
      this.$router.push({
        name: "statisticsEducational",
      });
    },
    handleTodolistLink(type) {
      if (type === "time-out-no-rollcall") {
        this.$router.push({
          name: "rollCallRecord",
          query: {
            tab: "timeoutNotPointList",
          },
        });
      }
      if (type === "lesson-cost-exceed") {
        this.$router.push({
          name: "rollCallRecord",
          query: {
            tab: "rollCallStudentList",
          },
          params: {
            type: "todo-list",
            exceed_status: "2",
          },
        });
      }
      if (type === "waiting-approval") {
        this.$router.push({
          name: "approveLog",
          params: {
            tab: "all",
            status_arr: "[1]",
          },
        });
      }
      if (type === "waiting-leave") {
        this.$router.push({
          name: "rollCallRecord",
          query: {
            tab: "leaveApplication",
          },
        });
      }
      if (type === "renewal-reminder") {
        this.$router.push({
          name: "renewalReminder",
        });
      }
      if (type === "latent-with-no-staff") {
        this.$router.push({
          name: "latent",
          params: {
            tab: "waiting",
            follow_staff_id: "0",
          },
        });
      }
      if (type === "student-with-no-class") {
        this.$router.push({
          name: "studentManage",
          params: {
            tab: "studying",
            class_id: "0",
          },
        });
      }
      if (type === "student-with-no-teacher") {
        this.$router.push({
          name: "studentManage",
          params: {
            tab: "studying",
            teacher_id: "0",
          },
        });
      }
      if (type === "student-with-no-staff") {
        this.$router.push({
          name: "studentManage",
          params: {
            tab: "studying",
            follow_staff_id: "0",
          },
        });
      }
      if (type === "multi-class-with-no-teacher") {
        this.$router.push({
          name: "classManage",
          params: {
            tab: "multiple",
            teacher_id: "0",
          },
        });
      }
      if (type === "single-class-with-no-teacher") {
        this.$router.push({
          name: "classManage",
          params: {
            tab: "single",
            teacher_id: "0",
          },
        });
      }
      if (type === "waiting-exchange") {
        this.$router.push({
          name: "integralExchange",
          params: {
            status: "1",
          },
        });
      }
    },
    peopleTotalLink(type) {
      if (type === "all-staff") {
        this.$router.push({
          name: "employeeManage",
          params: {
            tab: "storeStaff",
          },
        });
      }
      if (type === "all-teacher") {
        this.$router.push({
          name: "teacherManage",
        });
      }
      if (type === "all-latent") {
        this.$router.push({
          name: "latent",
          params: {
            tab: "latent",
          },
        });
      }
      if (type === "new-latent") {
        this.$router.push({
          name: "latent",
          params: {
            tab: "latent",
            start_time: dateFormat("YYYY-mm-dd", new Date()),
            end_time: dateFormat("YYYY-mm-dd", new Date()),
          },
        });
      }
      if (type === "today-experience") {
        this.$router.push({
          name: "experience",
          params: {
            start_date: dateFormat("YYYY-mm-dd", new Date()),
            end_date: dateFormat("YYYY-mm-dd", new Date()),
            experience_status_arr: "[2]",
          },
        });
      }
      if (type === "finish-experience") {
        this.$router.push({
          name: "experience",
          params: {
            start_date: dateFormat("YYYY-mm-dd", new Date()),
            end_date: dateFormat("YYYY-mm-dd", new Date()),
            experience_status: "[2]",
          },
        });
      }
      if (type === "all-student") {
        this.$router.push({
          name: "studentManage",
          params: {
            tab: "studying",
          },
        });
      }
      if (type === "new-student") {
        this.$router.push({
          name: "studentManage",
          params: {
            tab: "studying",
            start_time: dateFormat("YYYY-mm-dd", new Date()),
            end_time: dateFormat("YYYY-mm-dd", new Date()),
          },
        });
      }
      if (type === "all-history") {
        this.$router.push({
          name: "studentManage",
          params: {
            tab: "history",
          },
        });
      }
      if (type === "today-completion") {
        this.$router.push({
          name: "studentManage",
          params: {
            tab: "history",
            completion_start_date: dateFormat("YYYY-mm-dd", new Date()),
            completion_end_date: dateFormat("YYYY-mm-dd", new Date()),
          },
        });
      }
      if (type === "all-end" || type === "today-end") {
        this.$router.push({
          name: "studentManage",
          params: {
            tab: "purchase",
            stop_status: "2",
          },
        });
      }
    },
    toFollow() {
      if (this.followActiveTab === "today") {
        this.$router.push({
          name: "follow",
          params: {
            staff_id: String(UserModule.userInfo.staff_id),
            follow_start_time: dateFormat("YYYY-mm-dd", new Date()),
            follow_end_time: dateFormat("YYYY-mm-dd", new Date()),
            status: "[1]",
          },
        });
      }
      if (this.followActiveTab === "outday") {
        this.$router.push({
          name: "follow",
          params: {
            staff_id: String(UserModule.userInfo.staff_id),
            status: "[3]",
          },
        });
      }
    },
    toOrderLine(subject_id) {
      let start = "";
      let end = "";
      const v = this.buyCountTimeRange;
      if (v === "week") {
        start = dateFormat(
          "YYYY-mm-dd",
          new Date().getTime() - 7 * 24 * 60 * 60 * 1000
        );
      } else if (v === "twoweek") {
        start = dateFormat(
          "YYYY-mm-dd",
          new Date().getTime() - 14 * 24 * 60 * 60 * 1000
        );
      } else if (v === "month") {
        start = dateFormat(
          "YYYY-mm-dd",
          new Date().getTime() - 30 * 24 * 60 * 60 * 1000
        );
      } else {
        return false;
      }
      end = dateFormat("YYYY-mm-dd", new Date());
      this.$router.push({
        name: "orderManage",
        query: {
          tab: "orderline",
        },
        params: {
          start_date: start,
          end_date: end,
          subject_id: String(subject_id),
          order_type_arr: "[1]",
        },
      });
    },
    toStudentBirthday(type) {
      this.$router.push({
        name: "studentManage",
        query: {
          type: type,
          to: "studentBirthday",
        },
      });
    },
    getStudentBirthdayStatistics() {
      studentBirthdayStatisticsApi().then((res) => {
        if (res.error_code === 0) {
          this.studentBirthdayData = res.data.info;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  overflow-x: hidden;
  .block1 {
    display: flex;
    margin-bottom: 12px;
    .left {
      width: 0;
      overflow-x: hidden;
      flex: 1;
      display: flex;
      flex-direction: column;
      margin-right: 13px;
      .card {
        &:first-child {
          margin-bottom: 13px;
        }
      }
    }
    .right {
      width: 367px;
      min-width: 367px;
    }
  }
  .block2 {
    display: flex;
    .left {
      width: 367px;
      min-width: 367px;
    }
    .right {
      width: 0;
      overflow-x: hidden;
      flex: 1;
      display: flex;
      flex-direction: column;
      margin-left: 13px;
      .top {
        align-items: center;
      }
      .bottom {
      }
    }
  }
}
.card {
  padding: 13px;
  border-radius: 4px;
  background-color: #ffffff;
  .card-title {
    padding-bottom: 14px;
    border-bottom: 1px solid #e7e8ea;
    display: flex;
    .title {
      flex: 1;
      font-size: 16px;
      line-height: 16px;
      font-weight: bold;
      color: #5c5d5e;
    }
    .btns {
      .text {
        font-size: 14px;
        line-height: 16px;
        color: #5c5d5e;
      }
    }
  }
}
.store-data-wrap {
  display: flex;
  margin-top: 32px;
  .item {
    flex: 1;
    text-align: center;
    padding-bottom: 10px;
    position: relative;
    cursor: pointer;
    &::after {
      content: "";
      position: absolute;
      top: 4px;
      right: 0;
      height: 23px;
      border-right: 1px solid #e7e8ea;
    }
    &:last-child {
      &::after {
        display: none;
      }
    }
    .number {
      font-size: 32px;
      line-height: 32px;
      font-weight: bold;
      color: #474747;
    }
    .name {
      font-size: 14px;
      line-height: 14px;
      color: #5c5d5e;
      margin-bottom: 14px;
      font-weight: bold;
    }
  }
}
.cost-lesson-wrap {
  flex: 1;
  .cost-lesson {
    height: 200px;
  }
}
.todo-list-wrap {
  padding-top: 7px;
  .no-data {
    color: #909399;
    font-size: 12px;
    text-align: center;
    padding: 50px 0;
  }
  .item {
    display: flex;
    margin-bottom: 10px;
    cursor: pointer;
    &:last-child {
      margin-bottom: 0;
    }
    .tag {
      text-align: center;
      font-size: 12px;
      line-height: 24px;
      width: 70px;
      border-radius: 8px;
      background-color: #f6fafc;
      margin-right: 13px;
    }
    .text {
      flex: 1;
      line-height: 24px;
      font-size: 14px;
      align-items: center;
      color: #5c5d5e;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      .num {
        margin: 0 8px;
        color: #2a94ff;
      }
    }
  }
}
.people-total-wrap {
  background: none;
  .card-title-wrap {
    padding: 13px 13px 0 13px;
    background-color: #ffffff;
    border-radius: 4px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    .card-title {
      padding-bottom: 13px;
      border-bottom: 1px solid #e7e8ea;
      .title {
        font-size: 16px;
        line-height: 16px;
        font-weight: bold;
        color: #5c5d5e;
      }
    }
  }
  .people-total {
    .row {
      display: flex;
      background-color: #ffffff;
      border-radius: 4px;
      margin-bottom: 13px;
      padding: 21px 0;
      &:first-child {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
      .icon {
        width: 50px;
        height: 50px;
        margin-left: 32px;
        img {
          width: 56px;
          height: 58px;
        }
      }
      .item {
        flex: 1;
        text-align: center;
        position: relative;
        cursor: pointer;
        &:last-child {
          &::after {
            content: "";
            position: absolute;
            left: 0;
            top: 15px;
            height: 24px;
            border-right: 1px solid #e7e8ea;
          }
        }
        .number {
          margin-bottom: 14px;
          color: #474747;
          font-size: 32px;
          line-height: 32px;
          font-weight: bold;
          .plus {
            color: #4fb77c;
            font-size: 24px;
          }
        }
        .name {
          font-size: 14px;
          line-height: 14px;
          color: #5c5d5e;
        }
      }
    }
  }
}
/deep/.stdent-table-wrap {
  padding: 0 13px;
  border-radius: 4px;
  background-color: #ffffff;
  margin-bottom: 13px;
  height: 308px;
  flex: 1;
  margin-right: 13px;
  .head {
    display: flex;
    border-bottom: 1px solid #e7e8ea;
    margin-bottom: 13px;
    .tabs {
      flex: 1;
      .tab {
        display: inline-block;
        text-align: center;
        position: relative;
        cursor: pointer;
        line-height: 42px;
        margin-right: 26px;
        font-size: 16px;
        color: #5c5d5e;
        font-weight: bold;
        &.active {
          color: #4fb77c;
          &::after {
            content: "";
            position: absolute;
            bottom: -1px;
            left: 27px;
            right: 27px;
            border-bottom: 2px solid #4fb77c;
          }
        }
      }
    }
    .btns {
      cursor: pointer;
      margin-top: 5px;
      .my,
      .all {
        display: inline-block;
        border-radius: 4px;
        padding: 7px 16px;
        font-size: 14px;
      }
      .my {
        border: 1px solid #4fb77c;
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
        background-color: #f0fff7;
        color: #4fb77c;
      }
      .all {
        border: 1px solid #e7e8ea;
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
        border-left: 0;
        color: #5c5d5e;
      }
    }
  }
  .stdent-table {
    height: 250px;
    overflow: hidden auto;
    .mwow-table {
      border: 0 !important;
      &::before {
        display: none;
      }
      .blue {
        color: #2a94ff;
        font-weight: bold;
      }
      .el-table__header-wrapper {
        .el-table__header {
          thead {
            th {
              background-color: #eef8f2 !important;
              color: #5c5d5e !important;
              font-weight: bold !important;
              font-size: 14px !important;
            }
          }
        }
      }
      .el-table__body-wrapper {
        .el-table__empty-block {
          min-height: 200px;
        }
      }
    }
  }
}
/deep/.buy-total-wrap {
  flex: 1;
  padding-top: 0;
  .no-data {
    color: #909399;
    font-size: 12px;
    text-align: center;
    padding: 100px 0 0 0;
  }
  .title {
    line-height: 42px;
    color: #5c5d5e;
    display: flex;
    border-bottom: 1px solid #e7e8ea;
    .text {
      font-size: 16px;
      font-weight: bold;
      flex: 1;
    }
    .btns {
      .el-select {
        width: 90px;
        .el-input__inner {
          border: 0 !important;
        }
      }
    }
  }
  .buy-total {
    height: 339px;
  }
}
.no-data {
  position: relative;
  min-height: 200px;
  text-align: center;
  .person {
    height: 190px;
  }
  .img-text {
    margin-top: 10px;
  }
}
.student-birthday-wrap {
  border-radius: 4px;
  padding: 0 13px;
  width: 367px;
  min-width: 367px;
  height: 308px;
  margin-bottom: 13px;
  .card-title {
    padding-bottom: 0;
    .title {
      height: 42px;
      line-height: 42px;
    }
  }
  .birthday-wrap {
    margin-top: 13px;
    padding: 0 5px;

    .birthday-item {
      cursor: pointer;
      margin-bottom: 20px;
      .birthday-left {
        flex: 1;
      }
      .birthday-right {
        flex: 1;
      }
      .birthday-icon {
        width: 26px;
        height: 26px;
        img {
          width: 100%;
        }
      }
      .birthday-text {
        margin: 0 5px;
        font-size: 14px;
        color: #5c5d5e;
      }
      .birthday-count {
        color: #4fb77c;
        font-size: 14px;
      }
    }
  }
}
.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
